import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArrowUpToLineIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M8.46686 13.8915V5.95349C8.46686 5.67949 8.24387 5.45737 7.9688 5.45737C7.69374 5.45737 7.47075 5.67949 7.47075 5.95349V13.8915C7.47075 14.1655 7.69374 14.3876 7.9688 14.3876C8.24387 14.3876 8.46686 14.1655 8.46686 13.8915Z"
      fill="currentColor"
    />
    <path
      d="M8.32131 5.60271C8.12686 5.40902 7.81154 5.40913 7.61703 5.60271L4.29601 8.90988C4.10162 9.10352 4.10184 9.41766 4.29601 9.61143C4.49052 9.80518 4.80579 9.80518 5.00029 9.61143L7.96917 6.65407L10.9371 9.61143C11.1316 9.80518 11.4468 9.80518 11.6413 9.61143C11.8357 9.41767 11.8358 9.10358 11.6413 8.90988L8.32131 5.60271Z"
      fill="currentColor"
    />
    <path
      d="M1.49417 3.30717V5.95349C1.49417 6.22749 1.71716 6.44962 1.99223 6.44962C2.26729 6.44962 2.49028 6.22749 2.49028 5.95349V3.30717C2.49037 3.08799 2.57787 2.87786 2.73347 2.72287C2.88907 2.56788 3.10001 2.48071 3.32005 2.48062H12.6177C12.8377 2.48071 13.0487 2.56788 13.2043 2.72287C13.3599 2.87786 13.4474 3.08799 13.4475 3.30717V5.95349C13.4475 6.22749 13.6705 6.44962 13.9455 6.44962C14.2206 6.44962 14.4436 6.22749 14.4436 5.95349V3.30717C14.4435 2.82483 14.251 2.3624 13.9086 2.02132C13.5662 1.68025 13.1019 1.48846 12.6177 1.48838H3.32005C2.83583 1.48846 2.37159 1.68025 2.02919 2.02132C1.68679 2.3624 1.49426 2.82483 1.49417 3.30717Z"
      fill="currentColor"
    />
  </svg>
);
